import { IForm } from 'core-components/classes/models/IForm'

import { getName } from './helpers/getName'

import styles from './ItemRender.module.scss'

export const ItemRender = (item: IForm) => {
  const email = item.email || item.Id
  return (
    <div>
      {getName(item)}
      <div className={styles.email}>{email.trim()}</div>
    </div>
  )
}
